<template>
    <div class="training-submission">
        <el-table
            :data="projectsSubmissionList"
            @current-change="handleCurrentChange"
            style="width: 100%; flex: 1; border: 1px solid #EBEEF5; border-radius: 4px; border-bottom: none;"
            :header-cell-style="{ height: '42px', color: '#3E3E3E', background: '#F2F4F7', paddingLeft: '24px' }"
            :cell-style="{ height: '60px', color: '#333', paddingLeft: '24px' }"
        >
            <!-- <el-table-column type="index" label="序号" width="50"> </el-table-column>
            <el-table-column prop="s_name" label="姓名" width="100"></el-table-column>
            <el-table-column prop="update_time" label="提交时间" align="center"></el-table-column>
            <el-table-column prop="create_time" label="评分" width="250">
                <template slot-scope="scope">
                    <div class="pf-act-content" v-if="role === 3">
                        <template v-if="scope.row.teacher_score">
                            <span>{{ scope.row.teacher_score }}分</span>
                        </template>
                        <template v-else>
                            <el-input-number
                                v-model="scope.row.score"
                                controls-position="right"
                                class="pw-input"
                                :min="0"
                                :max="100"
                                style="width: 120px;"
                            ></el-input-number>
                            <el-tooltip content="确定之后，则无法修改分数" placement="top-start">
                                <el-button type="primary" size="small" class="pw-confirm-btn" @click="submitContent(scope.row)"
                                    >确定</el-button
                                >
                            </el-tooltip>
                        </template>
                    </div>
                    <div v-if="role === 4">
                        <span v-if="scope.row.teacher_score">{{ scope.row.teacher_score }}</span>
                        <span v-else>暂无评分</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="150">
                <template slot-scope="scope">
                    <el-link type="primary" @click="clickViewProjectDetail(scope.row)" :underline="false" style="color: #006EFF"
                        >查看详情</el-link
                    >
                </template>
            </el-table-column> -->
            <el-table-column type="index" label="序号" width="80"> </el-table-column>

            <el-table-column label="姓名">
                <template slot-scope="scope">{{ scope.row.s_name }}</template>
            </el-table-column>

            <el-table-column label="提交时间">
                <template slot-scope="scope">{{ scope.row.time }}</template>
            </el-table-column>

            <el-table-column label="评定状态" v-if="role !== 4">
                <template slot-scope="scope">
                    <span :class="{ fail: scope.row.status === 2 }">{{ scope.row.status === 1 ? "已提交" : scope.row.status === 0?'未提交':"打回重做" }}</span>
                </template>
            </el-table-column>

            <!-- 学生得分列 -->
            <el-table-column label="得分" v-if="role === 4">
                <template slot-scope="scope">
                    {{ scope.row.teacher_status === 0 || scope.row.status !== 1 ? "-" : scope.row.teacher_score }}
                </template>
            </el-table-column>

            <!-- 教师得分打分列 -->
            <el-table-column label="得分" v-if="role !== 4">
                <template slot-scope="scope">
                    <div class="table-scoring" v-if="scope.row.status === 1">
                        <!-- <el-input-number
                            v-model="scope.row.teacher_score"
                            controls-position="right"
                            :precision="2"
                            :min="0"
                            :max="100"
                            size="small"
                        ></el-input-number>
                        <el-button slot="trigger" size="small" type="primary" @click="confirmScore(scope.row)">确定</el-button> -->
                        {{ scope.row.teacher_score }}
                    </div>

                    <span v-else>-</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <div class="table-operate">
                        <el-button type="text" @click="handleAssessmentDetail(scope.row)" v-if="scope.row.status === 1">查看</el-button>
                        <span v-else>-</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            v-if="role === 3"
            class="pages-center"
            background
            :current-page.sync="projectPages.currentPageNum"
            :page-size="projectPages.eachPageNum"
            :total="projectPages.total"
            layout="prev, pager, next, jumper"
            @current-change="projectCurrentChange"
        >
        </el-pagination>
        <!--S 查看详情弹窗-->
        <el-dialog title="查看详情" :visible.sync="viewProjectDetail" width="1100px" class="submit-detail">
            <el-scrollbar class="detail-box content">
                <div class="detail-box_answer">
                    <div class="answer-content" v-html="submit_projects_content"></div>

                    <div class="answer-file-list">
                        <div class="file-item" v-for="item in files" :key="item.url">
                            <img :src="getFileIcon(item.name)" alt="" />

                            <div class="file-item_info">
                                <div class="info-top">{{ formatFileName(item.name) }}</div>

                                <div class="info-bottom">
                                    <div class="info-bottom_size">{{ item.size }}</div>
                                    <div class="info-bottom_operate">
                                        <el-button type="text" v-if="getIsPreview(item.name)" @click="previewSource(item)">预览</el-button>
                                        <el-button type="text" @click="downLoadSource(item)">下载</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div style="display: flex;min-height: 200px;">
                    <span class="detail-text" v-html="submit_projects_content"></span>
                </div> -->
                <div class="teacher-comments">
                    <span class="text">AI评分</span>
                    <span class="comments" v-if="ai_evaluate">{{ ai_evaluate }}</span>
                    <span class="comments" v-else style="color: #999999;">暂无AI评分</span>
                </div>

                <div class="teacher-comments" v-if="role === 3 && analysis && analysis.name">
                    <span class="text">{{ analysis.name }}</span>
                    <span class="comments" style="padding-block: 10px;">
                        <div v-html="analysis.value"></div>
                    </span>
                </div>

                <div class="teacher-comments" v-if="role === 4">
                    <span class="text">教师评语</span>
                    <span class="comments" v-if="teacher_comment">{{ teacher_comment }}</span>
                    <span class="comments" v-else>暂无评语</span>
                </div>
                <div class="teacher-comments" v-if="role === 3">
                    <span class="text">教师评语</span>
                    <el-input
                        class="textarea"
                        type="textarea"
                        :rows="6"
                        style="resize:none"
                        placeholder="请输入内容"
                        v-model="teacher_comment"
                    >
                    </el-input>
                </div>
            </el-scrollbar>
            <span slot="footer" class="dialog-footer">
                <el-button @click="viewProjectDetail = false">取消</el-button>
                <el-button type="primary" @click="viewProjectDetail = false" v-if="role === 4">确定</el-button>
                <el-button type="primary" @click="submitContent" v-if="role === 3">确定</el-button>
            </span>
        </el-dialog>
        <!--E 查看详情弹窗-->

        <div class="preview-box" v-if="previewUrl">
            <ElImageViewer class="preview-img" :url-list="[previewUrl]" alt="" v-if="['jpg', 'png'].includes(getFileExtensiion)" />

            <i class="el-icon-close" @click="closePreview"></i>
        </div>
    </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
    name: "ProjectSubmissionModule",
    props: {
        analysis: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            role: Number(localStorage.getItem("role")),
            //项目提交列表
            projectsSubmissionList: [],
            //提交内容
            submit_projects_content: "",
            //是否显示查看详情弹窗
            viewProjectDetail: false,
            //教师评语
            teacher_comment: "",
            //分数
            teacher_score: 0,
            //学生提交的id
            student_submit_id: "",
            //分页
            projectPages: {
                currentPageNum: 1,
                eachPageNum: 10,
                total: 0,
            },
            currentRow: null,
            ai_evaluate: "", // ai评分
            files: [], // 文件列表
            previewUrl: "", // 图片预览路径
            currentRow: null,
        };
    },
    components: {
        ElImageViewer,
    },
    computed: {
        // 获得文件扩展名
        getFileExtensiion() {
            const fileExtension = this.previewUrl?.slice(((this.previewUrl.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
            return fileExtension;
        },
    },
    mounted() {
        this.getStudentProject();
    },
    methods: {
        //获取学生提交列表
        getStudentProject() {
            console.log("pppppppppp");
            
            // let param = {
            //     project_id: this.$route.query.p_id,
            //     sx_id: this.$route.query.sx_id,
            //     page: this.projectPages.currentPageNum,
            //     limit: this.projectPages.eachPageNum,
            // };
            // this.$shttp.axiosGetBy(
            //     this.$api.drill_showStuPutDrillList,
            //     param,
            //     (res) => {
            //         if (res.code === 200) {
            //             this.projectsSubmissionList = res.data.data;
            //             this.projectPages.total = res.data.total;
            //         } else {
            //             this.$message.error(res.msg);
            //         }
            //     },
            //     (err) => {
            //         console.log(err);
            //     },
            // );
            const params = {
                course_id: Number(localStorage.getItem("course_id")),
                course_chapter: Number(localStorage.getItem("teacherChapter")) || Number(localStorage.getItem("studentChapter")),
                course_node: Number(localStorage.getItem("teacherNode")) || Number(localStorage.getItem("studentNode")),
                project_id: Number(localStorage.getItem("project_id")),
                page: this.projectPages.currentPageNum,
                limit: this.projectPages.eachPageNum,
                type:Number(localStorage.getItem("project_type"))
            };
              if(Number(localStorage.getItem("project_type"))==3){
                    delete params.course_id
                    delete params.course_chapter
                    delete params.course_node
                }
                if(Number(localStorage.getItem("project_type"))==2){
                   
                    params.course_chapter=-1
                    params.course_node=-1
                }

            if (this.role !== 4) params.c_id = Number(localStorage.getItem("class_id"));

            this.$shttp.axiosGetBy(this.$api.training_assessment_list, params, (res) => {
                if (res.code === 200) {
                    this.projectsSubmissionList = res.data.list || [];
                    this.projectPages.total = res.data.total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
              // 查看评价详情
              handleAssessmentDetail(row) {
                    if (row.status !== 1) {
                        this.$message.warning("学生暂未提交");
                        return;
                    }
                let role=localStorage.getItem("role")
             
                // 如果是从上课中过来的 不管了 type==2
                if(Number(localStorage.getItem("project_type")==2)){
                    this.$router.push({path:"/course/practical/scoreBreakdown",query:{s_id:row.s_id,...this.$route.query}})
                }
                // this.$router.push({path:role==4?"/qualityCourse/project/scoreBreakdown":'/qualityCourse/scoreBreakdown',query:{s_id:row.s_id,...this.$route.query}})
                if(Number(localStorage.getItem("project_type")==3)){
                    this.$router.push({path:"/qualityCourse/project/scoreBreakdown",query:{s_id:row.s_id,...this.$route.query}})
                }
                    // this.dialogData.p_id = row.id;
                    // this.dialogData.id = this.$route.query.id;
                    // this.dialogData.s_id = row.s_id;
                    // this.dialogData.visible = true;
        },

        // 下载文件
        downLoadSource(file) {
            const link = document.createElement("a");
            link.href = file.url;
            link.download = file.name;
            link.click();
        },

        // 预览文件
        previewSource(file) {
            const fileExtension = file.url?.slice(((file.url.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();

            if (["jpg", "png"].includes(fileExtension)) {
                this.previewUrl = file.url;
            } else {
                const routeHref = this.$router.resolve({
                    path: "/training/preview",
                    query: {
                        src: file.url,
                    },
                }).href;

                window.open(routeHref, "__blank");
            }
        },

        // 是否可以预览。除了压缩包类型都可预览
        getIsPreview(fileName) {
            const fileExtension = fileName?.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
            const noPreviewExtensions = ["rar", "zip"];
            let isPreview = true;

            if (noPreviewExtensions.includes(fileExtension)) isPreview = false;

            return isPreview;
        },

        // 定义函数来计算字符的单位长度
        getUnitLength(char) {
            // 中文字符
            if (/[\u4e00-\u9fa5]/.test(char)) {
                return 2;
            }

            // 中文2单位标点
            if (/[，。！？、；：“”‘’（）【】《》——]/.test(char)) {
                return 2;
            }

            // 大写字母占2个单位
            if (/^[A-Z]$/.test(char)) {
                return 2;
            }

            // 英文小写字母和数字，占1个单位
            if (/^[a-z0-9]$/.test(char)) {
                return 1;
            }

            return 1; // 默认单位为 1
        },

        // 格式化文件名
        formatFileName(fileName, nameLength = 34) {
            // 提取文件扩展名
            const extIndex = fileName.lastIndexOf(".");
            const fileExt = fileName.slice(extIndex); // 包括点号的扩展名

            // 去掉扩展名部分，获取文件名
            const nameWithoutExt = fileName.slice(0, extIndex);

            // 计算文件名的单位长度
            let unitCount = 0;
            let i = 0;
            while (i < nameWithoutExt.length && unitCount <= nameLength) {
                unitCount += this.getUnitLength(nameWithoutExt[i]);
                i++;
            }

            // 如果单位长度没有超过38个单位，直接返回原文件名
            if (unitCount <= nameLength) {
                return fileName;
            }

            // 截取文件名的前一部分
            const filePart = {
                lastPart: "",
                lastPartCount: 0,
                firstPart: "",
                firstPartCount: 0,
            };

            for (let index = nameWithoutExt.length - 1; index >= 0; index--) {
                if (filePart.lastPartCount < 4) {
                    filePart.lastPart = nameWithoutExt[index] + filePart.lastPart;
                    filePart.lastPartCount += this.getUnitLength(nameWithoutExt[index]);
                } else {
                    break;
                }
            }

            for (let index = 0; index < nameWithoutExt.length; index++) {
                if (filePart.firstPartCount < nameLength - filePart.lastPartCount - 4) {
                    filePart.firstPart += nameWithoutExt[index];
                    filePart.firstPartCount += this.getUnitLength(nameWithoutExt[index]);
                } else {
                    break;
                }
            }

            // 格式化文件名
            return filePart.firstPart + "...." + filePart.lastPart + fileExt;
        },

        // 获取文件icon
        getFileIcon(fileName) {
            const iconList = {
                rar: require("../../assets/icons/zip-icon.svg"),
                zip: require("../../assets/icons/zip-icon.svg"),
                doc: require("../../assets/icons/doc-icon.svg"),
                docx: require("../../assets/icons/doc-icon.svg"),
                xls: require("../../assets/icons/xls-icon.svg"),
                xlsx: require("../../assets/icons/xls-icon.svg"),
                pdf: require("../../assets/icons/pdf-icon.svg"),
                jpg: require("../../assets/icons/img-icon.svg"),
                png: require("../../assets/icons/img-icon.svg"),
            };
            const fileExtension = fileName?.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
            return iconList[fileExtension] || iconList["jpg"];
        },

        //查看详情
        clickViewProjectDetail(row) {
            // this.viewProjectDetail = true;
            // this.submit_projects_content = row.content;
            // this.teacher_comment = row.teacher_comment;
            // this.student_submit_id = row.id;
            const param = {
                // project_id: Number(this.$route.query.p_id),
                s_id: row.s_id,
            };

            if (this.$route.query.sx_id) {
                param.sx_id = Number(this.$route.query.sx_id);
            } else if (this.$route.query.p_id) {
                param.project_id = Number(this.$route.query.p_id);
            }

            this.$shttp.axiosGetBy(this.$api.showStuDirllDetail, param, (res) => {
                if (res.code === 200) {
                    this.teacher_comment = res.data.teacher_comment;
                    this.ai_evaluate = res.data.ai_evaluate;
                    this.files = res.data.file;
                    this.student_submit_id = res.data.id;
                    this.submit_projects_content = res.data.content;

                    this.viewProjectDetail = true;
                } else {
                    this.$message.error("获取详情错误");
                }
            });
        },
        handleCurrentChange(val) {
            if (val) {
                this.currentRow = val;
                this.student_submit_id = val.id;
            }
        },
        //提交评语/分数
        submitContent(item) {
            let formData = new FormData();
            formData.append("id", this.student_submit_id);
            if (this.teacher_comment) {
                formData.append("teacher_comment", this.teacher_comment);
            }
            if (item) {
                formData.append("teacher_score", item.score);
            }
            this.$shttp.axiosPost(
                this.$api.drill_teaCommentStuDrill,
                formData,
                (res) => {
                    if (res.code === 200) {
                        this.viewProjectDetail = false;
                        this.getStudentProject();
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }
                },
                (err) => {
                    console.log(err);
                },
            );
        },
        //分页
        projectCurrentChange(val) {
            this.projectPages.currentPageNum = val;
            this.getStudentProject();
        },

        // 关闭文件预览
        closePreview() {
            this.previewUrl = "";
        },
    },
};
</script>

<style scoped lang="scss">
ul,
li {
    margin: 0;
    padding: 0;
    list-style: none;
}
.fail {
        color: #ff2626;
    }
.training-submission {
    height: calc(100% - 90px);
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 14px 30px 30px 30px;
    .detail-title {
        cursor: pointer;
        &.detail-title:hover {
            color: #409eff;
        }
    }
    .detail-text {
        margin-bottom: 10px;
        ::v-deep img {
            max-width: 100%;
            max-height: 100%;
        }
    }

    // ::v-deep.el-dialog__header {
    //     border-bottom: 1px solid #eaeaea;
    // }
    // ::v-deep.el-dialog__footer {
    //     text-align: right;
    //     padding: 40px 20px;
    // }
    // ::v-deep.el-dialog__body {
    //     padding: 10px 20px;
    // }
    // ::v-deep.el-table__body-wrapper {
    //     height: calc(100% - 50px);
    //     overflow-y: auto;
    // }
    // ::v-deep.el-dialog__title {
    //     font-size: 14px;
    // }
    // ::v-deep .el-dialog {
    //     .el-dialog__body {
    //         height: 400px;
    //         box-sizing: border-box;
    //         ::v-deep .el-scrollbar__wrap {
    //             overflow-x: hidden;
    //         }
    //     }
    // }
    ::v-deep .el-dialog {
        position: absolute;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-height: 90vh;
        overflow: hidden;

        .el-dialog__header {
            padding: 15px 20px;
        }

        .el-dialog__body {
            padding: 0;
        }
    }
}
.pages-center {
    margin: 40px 0 20px 0;
}
.teacher-comments {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    .comments {
        padding: 20px;
        background-color: #fcfcfc;
    }
    .textarea {
        padding-top: 10px;
    }
}
.pw-input {
    margin-right: 5px;
}

.detail-box {
    ::v-deep .el-scrollbar__wrap {
        width: calc(100% - 40px);
        max-height: calc(90vh - 55px - 66px - 40px);
        // padding: 20px 20px;
        box-sizing: border-box;
        margin: 10px 20px !important;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    &_answer {
        .answer-file-list {
            width: 100%;
            display: flex;
            gap: 10px;
            flex-wrap: wrap;

            .file-item {
                width: calc((100% - 20px) / 3);
                height: 72px;
                border-radius: 4px;
                background-color: #f6f6f6;
                box-sizing: border-box;
                padding: 16px;
                display: flex;
                gap: 10px;

                img {
                    width: 40px;
                    height: 40px;
                    object-fit: cover;
                }

                &_info {
                    width: calc(100% - 50px);

                    .info-top {
                        white-space: nowrap;
                    }

                    .info-bottom {
                        margin-top: 6px;
                        display: flex;
                        justify-content: space-between;
                        align-content: center;

                        &_size {
                            color: #999999;
                        }

                        .el-button {
                            padding-block: 0;
                        }
                    }
                }
            }
        }
    }
}

.preview-box {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    z-index: 9999;
    background-color: rgba(0, 0, 0, 0.3);

    ::v-deep .el-image-viewer__wrapper {
        .el-image-viewer__mask {
            display: none;
        }

        .el-icon-circle-close {
            display: none;
        }

        .el-image-viewer__canvas img {
            width: 40% !important;
            height: auto !important;
        }
    }

    .el-icon-close {
        position: absolute;
        right: 50px;
        top: 30px;
        font-size: 40px;
        cursor: pointer;
        color: #ffffffda;
        z-index: 9999;
    }
}
</style>
